<se-fe-card
  class="eventCard"
  [style]="'border-color:' + cardAccentColor +';'">
  <se-fe-card-content class="cardContent">
    @if (dataEvent.tags && dataEvent.tags.length > 0) {
      <div>
        @for (tag of dataEvent.tags; track tag) {
          <span [class]="'pl-tag--' + tag.color">{{ tag.value.toUpperCase() }}</span>
        }
      </div>
    }
    @if ((!dataEvent.tags || dataEvent.tags.length === 0) && range) {
      <p>{{ range }}</p>
    }
    <se-fe-header>
      @if (dataEvent.titleAttributes) {
        <a seFeHeaderTitle
          seFeLink="low"
          [href]="dataEvent.titleAttributes.href || undefined "
          class="se-event-card__title">
          {{ dataEvent.title }}
        </a>
      }
      @if (!dataEvent.titleAttributes) {
        <div seFeHeaderTitle
          class="se-event-card__title">
          {{ dataEvent.title }}
        </div>
      }
      @if (dataEvent.subtitle) {
        <div seFeHeaderSubtitle
          class="se-event-card__subtitle">
          {{ dataEvent.subtitle }}
        </div>
      }
      @if (playChipOpts) {
        <div  seFeHeaderActions>
          <se-fe-play-chip
            [attr.seFeDataOptions]="playChipOpts">
          </se-fe-play-chip>
        </div>
      }
    </se-fe-header>

    @if (dataEvent.locationAttributes) {
      <a
        seFeLink="low"
        [href]="dataEvent.locationAttributes.href || undefined"
        class="se-event-card__location">
        {{ dataEvent.location }}
      </a>
    }
    @if (!dataEvent.locationAttributes && dataEvent.location) {
      <div
        class="se-event-card__location">
        {{ dataEvent.location }}
      </div>
    }
    <app-rsvp-list
      [rsvps]="rsvps || []"
      [hasAllRsvps]="hasAllRsvps()"
      [headerAvatars]="shownAvatars"
      [additionalAvatars]="avatarsNotShown"
      (onRsvp)="emitEvent($event)">
    </app-rsvp-list>
  </se-fe-card-content>
</se-fe-card>
